import { useAppStore } from '@/store/app';
import useExchangeRates from './useExchangeRates';
import { computed } from 'vue';
import { currencies, defaultCurrency } from '@/constants';

export default function useCurrentCurrency() {
  const store = useAppStore();
  const exchangeRates = useExchangeRates();

  const currency = computed(() => {
    return currencies.find((c) => c.name === store.currency) || defaultCurrency;
  });

  const rate = computed(() => {
    return exchangeRates.data.value?.[store.currency] || 1;
  });

  return {
    currency,
    rate,
  };
}
